import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sso-error',
  standalone: true,
  imports: [],
  templateUrl: './sso-error.component.html',
  styleUrl: './sso-error.component.css'
})
export class SsoErrorComponent {

}
